export default "__VITE_ASSET__BJzQvMrx__"